import styled, { createGlobalStyle, css, keyframes } from "styled-components";

export const GlobalStyle = createGlobalStyle`
  
  .react_trello_dragLaneClass {
    box-shadow: 0 0.6px 1.8px 0 rgb(0 0 0 / 11%), 0 3.2px 7.2px 0 rgb(0 0 0 / 13%);
    margin: 5px;
  }

  .icon-overflow-menu-horizontal:before {
    content: "\\E91F";
  }
  .icon-lg, .icon-sm {
    color: #798d99;
  }
  .icon-lg {
    height: 32px;
    width: 32px;
  }

  /* Limit card title h3 to single line */
  .react-trello-card h3 {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-word;
  }

  /* Limit card content p to single line */
  .react-trello-card p {
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-word;
  }
`;

export const BoardWrapper = styled.div`
  overflow-y: hidden;
  color: #393939;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  background-color: transparent;
  width: 100%;
  padding-right: 80px;
  overflow-x: auto;

  > div {
    width: fit-content;
    height: 100%;
  }
`;

export const Header = styled.header`
  margin-bottom: 10px;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
`;

export const Section = styled.section`
  background-color: #fff;
  border-radius: 3px;
  margin: 5px 5px;
  position: relative;
  padding: 5px;
  display: inline-flex;
  height: 100%;
  flex-direction: column;
`;

const cardLaneAnimation = keyframes`
 0% { transform: translate3d(0px, -48px, 0px) }
 100% { transform: translate3d(0px, 0px, 0px) }
`;
const listMenuAnimation = keyframes`
 0% { transform: translate3d(0px, -10px, 0px) }
 100% { transform: translate3d(0px, 0px, 0px) }
`;

export const CardLaneForm = styled.section`
  flex-wrap: nowrap;
  max-width: 260px;
  min-height: 40px;
  background-color: #ffffff;
  border-radius: 2px;
  box-shadow:
    0 0.6px 1.8px 0 rgb(0 0 0 / 11%),
    0 3.2px 7.2px 0 rgb(0 0 0 / 13%);
  margin: 5px;
  flex-direction: column;
  display: flex;
  padding: 5px;
  animation: 100ms cubic-bezier(0.1, 0.9, 0.2, 1) 0s 1 normal none running ${cardLaneAnimation};
`;

export const CardWrapper = styled.article`
  border-radius: 8px;
  background-color: #fff;
  position: relative;
`;

export const CardFromItem = styled.div`
  display: flex;
  align-items: center;
  padding: 2px 2px;
`;

export const CardFormFooter = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 2px;
  color: #605e5c;
  justify-content: flex-end;
`;

export const AddCardButton = styled.button`
  align-items: center;
  cursor: pointer;
  padding: 0;
  background-color: #2563eb;
  border: none;
  border-radius: 2px;
  min-width: 100px;
  max-width: 236px;
  min-height: 32px;
  align-self: flex-end;
  color: #ffffff;
  padding: 5px 20px;
`;

export const CancelCardButton = styled.button`
  align-items: center;
  cursor: pointer;
  padding: 0;
  background-color: #fff;
  border: none;
  border-radius: 2px;
  min-width: 100px;
  max-width: 236px;
  min-height: 32px;
  align-self: flex-end;
  color: #000;
  padding: 5px 20px;
  margin-right: 10px;
  border: 1px solid #c5c5c5;
`;

export const LaneHeaderWrapper = styled.div`
  padding: 5px;
`;

export const LaneHeader = styled(Header)`
  margin-bottom: 0px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 2px;
  border: 1px solid transparent;
  height: 32px;
  position: relative;
`;

export const LaneFooter = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  position: relative;
  height: 10px;
`;

export const ScrollableLane = styled.div`
  flex: 1;
  min-width: 250px;
  overflow-x: hidden;
  align-self: center;
  margin-top: 4px;
  flex-direction: column;
  justify-content: space-between;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const WrapperContainer = styled.div`
  overflow: visible;
  box-sizing: border-box;

  .smooth-dnd-container.vertical > .smooth-dnd-draggable-wrapper {
    overflow: unset;
  }
`;

export const Title = styled.div`
  display: flex;
  align-items: center;
  line-height: unset;
  height: 100%;
  width: 100%;
  cursor: ${(props) => (props.draggable ? "grab" : `pointer`)};

  .Polaris-Avatar {
    margin-right: 6px;
    height: 28px;
    width: 28px;
    min-width: 28px;
  }
`;

export const RightContent = styled.span`
  width: 38%;
  text-align: right;
  padding-right: 10px;
`;

export const MovableCardWrapper = styled(CardWrapper)`
  padding: 10px 12px;
  min-width: 230px;
  max-width: 250px;
  border: 1px solid #e5e7eb;
  box-shadow: 0 1px 2px 0 rgb(0 0 0 / 5%);
  margin: 4px 5px;
  transition:
    box-shadow 0.15s ease,
    border-color 0.15s ease;

  &:hover {
    box-shadow: 0 2px 8px 0 rgb(0 0 0 / 8%);
    border-color: #d1d5db;
    cursor: grab;
    .btn-action {
      display: flex;
      padding: 0px;
      background: white;
    }
  }
`;

export const CardHeader = styled(Header)`
  color: #000;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const CardTitle = styled(Title)`
  font-weight: 400;
  color: #323130;
  text-overflow: ellipsis;
  margin-left: 4px;
  overflow: hidden;
  flex: 1;
  min-width: 0;
  margin-right: 10px;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  align-items: start;

  ${(props) =>
    props.isCompletedTask &&
    css`
      text-decoration: line-through;
    `}
`;

export const CardRightContent = styled(RightContent)``;

export const Detail = styled.div`
  padding: 5px;
  color: #4d4d4d;
  white-space: pre-wrap;
`;

export const Footer = styled.div`
  border-top: 1px solid #eee;
  padding-top: 6px;
  text-align: right;
  display: flex;
  justify-content: flex-end;
  flex-direction: row;
  flex-wrap: wrap;
`;

export const AddCardLink = styled.div`
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  border-radius: 2px;
  box-shadow:
    0 0.6px 1.8px 0 rgb(0 0 0 / 11%),
    0 3.2px 7.2px 0 rgb(0 0 0 / 13%);
  cursor: pointer;
  color: #2563eb;
  height: 40px;
  cursor: pointer;
  padding: 10px;
  display: flex;
  align-items: center;
  justify-content: start;
  margin: 10px 5px 0px 5px;

  &:hover {
    box-shadow:
      0 1.2px 3.6px 0 rgb(0 0 0 / 11%),
      0 6.4px 14.4px 0 rgb(0 0 0 / 13%);
  }
`;

export const LaneTitle = styled.div`
  font-size: 15px;
  width: 100%;
  padding-top: 10px;
  height: auto;
`;

export const LaneSection = styled.section`
  background-color: #1fb6ff;
  border-radius: 3px;
  margin: 5px;
  position: relative;
  display: inline-flex;
  height: auto;
  flex-direction: column;
`;

export const NewLaneSection = styled(LaneSection)`
  width: 64px;
  color: #2563eb;
`;

export const NewLaneButtons = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
  width: 250px;

  button {
    margin: 0;
  }
`;

export const CardForm = styled.div`
  background-color: #e3e3e3;
`;

export const InlineInput = styled.textarea`
  overflow-x: hidden; /* for Firefox (issue #5) */
  word-wrap: break-word;
  min-height: 18px;
  max-height: 112px; /* optional, but recommended */
  resize: none;
  width: 100%;
  height: 18px;
  background-color: transparent;
  box-shadow: none;
  box-sizing: border-box;
  border-radius: 3px;
  border: 0;
  padding: 8px;
`;

export const LaneHeaderContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-right: 5px;
`;

export const ButtonOption = styled.button`
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  border-radius: 2px;
  opacity: 0;
  border: unset;
  padding: 0;
  cursor: pointer;
  outline: unset;
  > span {
    width: 2px;
    background: #6b6b6b;
    height: 2px;
    border-radius: 50%;
  }
`;

export const ContainerOption = styled.div`
  position: absolute;
  top: 30px;
  background: #fff;
  left: 0;
  padding: 10px;
  box-shadow: 0 8px 10px rgb(0 0 0 / 10%);
  border: solid 1px #f3f2f1;
  padding: 2px 0px;
  width: 180px;
  z-index: 2;
  animation: ${listMenuAnimation} 0.367s normal cubic-bezier(0.1, 0.9, 0.2, 1);
`;

export const OptionItem = styled.div`
  display: flex;
  align-items: center;
  height: 40px;
  padding: 5px 10px;
  &:hover {
    background-color: rgb(244, 244, 244);
    color: rgb(33, 33, 33);
  }
`;
